const values = {
  client_masters_data_tables: [
    {
      id: 1,
      key: "client_grade_data",
      name: "Master Grade Data",
      desc:
        "Manage the list of all grades in your organisation. For example - Grade 1, Primary 1, Nursery etc.",
      component: "GradeList",
    },
    {
      id: 2,
      key: "client_class_data",
      name: "Master Class Data",
      desc:
        "Manage the list of all classes/sections in your organisation. For example - Grade 1 - A, Grade 1-B etc.",
      component: "ClassList",
    },
    {
      id: 3,
      key: "referral_relation_data",
      name: "Master Referral Relation Data",
      desc:
        "Options for different types of people  who can refer the student. For example Class teacher, Mother, Coordinator etc.",
      component: "ReferralRelationList",
    },
    {
      id: 4,
      key: "client_role_data",
      name: "Master Role Data",
      desc:
        "Manage the list of different roles, that internal team members can play in an organisation. For example: Director, Principal, Class Teacher etc.",
      component: "RoleList",
    },
    {
      id: 5,
      key: "client_service_data",
      name: "Master Service Data",
      desc:
        "Manage the list of different services that can be added to a student from a particular organisation.",
      component: "ServiceList",
    },
    {
      id: 6,
      key: "client_step_data",
      name: "Master Step Data",
      desc:
        "Manage the list of different steps under services that can be added to a student from a particular organisation.",
      component: "StepList",
    },
    // {
    //     'id':6,
    //     'key': "resource_type_data",
    //     'name': "Service Master Data",
    //     'desc': "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    // },
    // {
    //     'id':7,
    //     'key': "resource_type_data",
    //     'name': "Service Step Master Data",
    //     'desc': "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    // },
  ],
  masters_data_tables: [
    {
      id: 1,
      name: "Masters Resource Type Data",
      desc:
        "The different types of resources that can be uploaded in the platform for example: Assessments, Home Activities, Videos, Audios",
      component: "ResourceTypeTable",
    },
    {
      id: 2,
      name: "Masters Skill Data",
      desc:
        "Categorisation type for resources uploaded in the platform on the basis of Skills.",
      component: "SkillsTable",
    },
    {
      id: 3,
      name: "Masters Age Group Data",
      desc:
        "Categorisation type for resources uploaded in the platform on the basis of age brackets according to suitability.",
      component: "AgeGroupTable",
    },
    {
      id: 4,
      name: "Masters Tag Data",
      desc:
        "Categorisation type for resources uploaded in the platform on the basis of tags, i.e. specific difficulties/disabilities the resource caters to.",
      component: "TagsTable",
    },
    {
      id: 5,
      name: "Masters Language Data",
      desc:
        "Categorisation type for resources uploaded in the platform on the basis of the language they are created in.",
      component: "ResourceLanguageTable",
    },
    {
      id: 6,
      name: "Masters Country Data",
      desc:
        "Categorisation type for resources uploaded in the platform on the basis of suitability for users from different countries.",
      component: "CountryTable",
    },
    {
      id: 7,
      name: "Masters Relation Data",
      desc:
        "Options for different types of relation with the student, to be defined while being added to the student’s team.",
      component: "RelationTable",
    },
    {
      id: 8,
      name: "Masters Gender Data",
      desc:
        "Options for different Gender types to be specified while entering student details into the platform.",
      component: "GenderTable",
    },
    {
      id: 9,
      name: "User Group Master Data",
      desc:
        "Manage the list of different user types, each having a specific set of permissions.",
      component: "UserGroupTable",
    },
    {
      id: 10,
      name: "Master Banner Data",
      desc:"Manage the list of banners.",
      component: "BannerTable",
    },
  ],
};
export default values;
